import { useState } from "react";
import JobComponent from "./jobinfo";

const filters = [
  {
    id: "Employment type",
    name: "Employment type",
    options: [
      { value: "Casual", label: "Casual" },
      { value: "Full Time", label: "Full Time" },
      { value: "Part Time", label: "Part Time" },
      { value: "Subcontractor", label: "Subcontractor" },
    ],
  },
  {
    id: "location",
    name: "Location",
    options: [
      { value: "Victoria", label: "Victoria" },
      { value: "South Australia", label: "South Australia" },
    ],
  },
];

export default function Example() {
  const [selectedFilters, setSelectedFilters] = useState({
    location: [],
    type: [],
  });

  const handleFilterChange = (filterName, value, checked) => {
    setSelectedFilters((prev) => {
      const currentValues = prev[filterName] || [];
      if (checked) {
        return { ...prev, [filterName]: [...currentValues, value] };
      } else {
        return {
          ...prev,
          [filterName]: currentValues.filter((item) => item !== value),
        };
      }
    });
  };

  return (
    <div className="bg-gradient-to-b from-custom-4 to-custom-6">
      <main className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">
        <div className="border-b border-gray-200 pb-10">
          <h1 className="text-4xl font-bold tracking-tight text-gray-900">
            Join Us
          </h1>
          <p className="mt-4 text-base text-gray-500">
            We are a destination for career cultivation with opportunities.
            Explore the variety of careers we offer across all facets of
            healthcare. To apply for a position, please email your cover letter
            and resume to us.
          </p>
        </div>
        
        <div className="mt-6 block lg:hidden grid grid-cols-1 gap-4">
          {filters.map((section) => (
            <fieldset key={section.id} className="p-4 rounded-lg">
              <legend className="text-sm font-medium text-gray-900">{section.name}</legend>
              <div
                className={
                  section.id === "Employment type"
                    ? "grid grid-cols-2 gap-2 mt-2"
                    : "flex space-x-4 mt-2 overflow-x-auto"
                }
              >
                {section.options.map((option) => (
                  <label
                    key={option.value}
                    className="flex items-center space-x-1 text-sm text-gray-700"
                  >
                    <input
                      type="checkbox"
                      value={option.value}
                      className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                      onChange={(e) =>
                        handleFilterChange(section.id, option.value, e.target.checked)
                      }
                    />
                    <span>{option.label}</span>
                  </label>
                ))}
              </div>
            </fieldset>
          ))}
        </div>
        <div className="pt-12 lg:grid lg:grid-cols-5 lg:gap-x-8 xl:grid-cols-5">
          <aside className="hidden lg:block lg:col-span-1">
            <h2 className="sr-only">Filters</h2>
            <form className="space-y-10 divide-y divide-gray-200">
              {filters.map((section) => (
                <fieldset key={section.name} className="pt-10">
                  <legend className="block text-sm font-medium text-gray-900">
                    {section.name}
                  </legend>
                  <div className="space-y-3 pt-6">
                    {section.options.map((option) => (
                      <div key={option.value} className="flex items-center">
                        <input
                          id={`${section.id}-${option.value}`}
                          name={`${section.id}[]`}
                          defaultValue={option.value}
                          type="checkbox"
                          className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                          onChange={(e) =>
                            handleFilterChange(section.id, option.value, e.target.checked)
                          }
                        />
                        <label htmlFor={`${section.id}-${option.value}`} className="ml-3 text-sm text-gray-600">
                          {option.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </fieldset>
              ))}
            </form>
          </aside>
          <div className="mt-6 lg:col-span-4 lg:mt-0 xl:col-span-4">
            <JobComponent selectedFilters={selectedFilters} />
          </div>
        </div>
      </main>
    </div>
  );
}
